import React from 'react';
import { Marker } from '@react-google-maps/api';

const MapMarker = ({ title, latitude, longitude, handleClick, draggable = false, handleDrag }) => (<Marker draggable={draggable} title={title} onClick={handleClick} onDrag={handleDrag} position={{ lat: parseFloat(latitude), lng: parseFloat(longitude) }}/>);

export default MapMarker;